import type { InternalAxiosRequestConfig } from 'axios';
import { hasHeader, setHeader } from 'api/httpHeaders';

/** Legacy transcript viewers send their link IDs without replacing caller IDs. */
export function applyLegacyTranscriptHeaders(
  config: InternalAxiosRequestConfig
): void {
  if (
    typeof window === 'undefined' ||
    !window.location.pathname.startsWith('/share-transcript')
  )
    return;

  const query = new URLSearchParams(window.location.search);
  const candidateId = query.get('candidateId');
  const campaignId = query.get('campaignId');
  if (!candidateId || !campaignId) return;

  if (!hasHeader(config.headers, 'transcript-candidateId')) {
    setHeader(config, 'transcript-candidateId', candidateId);
  }
  if (!hasHeader(config.headers, 'transcript-campaignId')) {
    setHeader(config, 'transcript-campaignId', campaignId);
  }
}
